export const yesNo = (v, nullValue = null) => v === null ? nullValue : v ? 'Yes' : 'No'

export const checkMark = (v, nullValue = 'clear') => v === null ? nullValue : v ? 'check' : 'clear'

export const cat = (vals = [], separator = ', ', conjunction = ' and ', oxford = true) => {
  if (!vals.length) return ''
  const {
    0: first,
    [vals.length - 1]: last,
    length
  } = vals
  if (length === 1) return first
  if (length === 2) return `${first}${conjunction}${last}`
  return `${vals.join(separator)}${oxford ? separator : ''}${conjunction}${last}`
}

export function mask (raw, _mask) {
  let i = 0
  if (!raw) return raw
  const v = raw.toString()
  return _mask.replace(/#/g, _ => v[i++])
}

export function percentage (value, decimals = 2, nullValue = null) {
  if (value === null) return nullValue
  const v = value ?? 0
  return `${(v * 100).toFixed(decimals)}%`
}
